import { FC, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import NewWindow from 'react-new-window';
import { logAnalytics } from 'shared/middlewares/analytics/logger';

export interface EmailServicePreviewContentProps {
  id?: string;
  referenceId: string;
  content: string;
}

export const EmailServicePreviewContent: FC<EmailServicePreviewContentProps> = ({ id, content, referenceId }) => {
  const intl = useIntl();

  const [isWindowOpen, setIsWindowOpen] = useState(false);

  return (
    <>
      <button
        id={id}
        type="button"
        className="btn btn-lg btn-default w-100 btn-icon-end"
        onClick={() => {
          setIsWindowOpen(true);
          logAnalytics.trackEvent('Email service', 'Preview email');
        }}
      >
        <FormattedMessage id="emailService.preview.placeholder" />
        <i className="icon ms-2">open_in_new</i>
      </button>

      {isWindowOpen && (
        <NewWindow
          copyStyles={false}
          center="parent"
          features={{ width: 700, height: 800 }}
          title={intl.formatMessage({ id: 'emailService.preview.title' }, { id: referenceId })}
          onUnload={() => setIsWindowOpen(false)}
        >
          <div
            style={{
              minWidth: '15rem',
              maxWidth: '80vw',
              margin: '48px auto',
              padding: '24px',
              border: '1px solid LightGray',
              fontFamily: 'Inter, Noto_Sans_JP, sans-serif',
              fontSize: 14,
              lineHeight: 1.5,
            }}
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </NewWindow>
      )}
    </>
  );
};
